import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './landeskennzeichen.list-view.html',
    styleUrls: ['./landeskennzeichen.list-view.scss']
})
export class LandeskennzeichenListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
